import { useField } from 'formik';

const MyTextInput = ({ refCheck, label, errorHandling = true, ...props }: any) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label htmlFor={props.id || props.name}>{label}</label>
      <input className="form-control" id={props.name} ref={refCheck} {...field} {...props} />
      {errorHandling && meta.touched && meta.error ? (
        <div className="error-msg">{meta.error}</div>
      ) : null}
    </>
  );
};

export default MyTextInput;
